import { render } from "./Units.vue?vue&type=template&id=225c82de&scoped=true"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"

import "@/assets/css/main.sass?vue&type=style&index=0&id=225c82de&lang=sass&scoped=true"
import "@/assets/css/units.sass?vue&type=style&index=1&id=225c82de&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225c82de"]])

export default __exports__